import { render, staticRenderFns } from "./TrendsColComponent.vue?vue&type=template&id=91e6a8fa"
import script from "./TrendsColComponent.vue?vue&type=script&lang=js"
export * from "./TrendsColComponent.vue?vue&type=script&lang=js"
import style0 from "./TrendsColComponent.vue?vue&type=style&index=0&id=91e6a8fa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports